// Placeholder
"use client";
import { usePowerSearch } from "../contexts/power-search-context";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import { mixpanelTrack } from "shared/trackEvents/mixpanelTracking";
import { isOpenRemunerationPlan } from "shared/plans";
import {
  POWER_SEARCH_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const ListedCompaniesFilter = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const currentUser = useSelector((state) => state.users.user);
  const { companyTopOption, updateFilter } = usePowerSearch();
  const options = [
    { label: "All", value: "all" },
    { label: "ASX200", value: "asx200" },
    { label: "ASX300", value: "asx300" },
  ];

  return (
    <div className="">
      <div
        className="d-flex align-items-cente mb-2"
        style={{ cursor: "pointer" }}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <Button
          variant="link"
          size="sm"
          style={{
            display: "inline-block",
            padding: 0,
            margin: 0,
            textDecoration: "none",
            marginRight: "4px",
            focus: "none",
            outline: "none",
            border: "none",
            boxShadow: "none",
            fontWeight: "bold",
          }}
        >
          {isExpanded ? "−" : "+"}
        </Button>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            margin: 0,
          }}
        >
          LISTED COMPANIES
        </p>
      </div>

      <div className={`${isExpanded ? "d-block" : "d-none"}`}>
        {options.map((opt) => (
          <div
            key={opt.value}
            className="d-flex col-gap-1 align-items-center mb-1"
          >
            <div className="">
              <input
                type="radio"
                id={`company-top-${opt.value}`}
                name="companyTopFilter"
                value={opt.value}
                checked={companyTopOption === opt.value}
                onChange={(e) => {
                  updateFilter("companyTopOption", e.target.value);

                  // Track listed companies filter selection
                  const eventName = isOpenRemunerationPlan(currentUser)
                    ? POWER_SEARCH_EVENT_NAMES.OR_POWER_SEARCH_FILTER_LISTED_COMPANIES_CLICKED
                    : POWER_SEARCH_EVENT_NAMES.OD_POWER_SEARCH_FILTER_LISTED_COMPANIES_CLICKED;

                  mixpanelTrack(eventName, {
                    [MIXPANEL_PROPS.FILTER_OPTION]: e.target.value,
                    userEmail: currentUser?.email,
                  });
                }}
              />
              <label htmlFor={`company-top-${opt.value}`}></label>
            </div>
            <label
              className="mb-0 ms-2 ml-1 text-uppercase"
              htmlFor={`company-top-${opt.value}`}
              style={{ flex: 1, fontSize: "14px", fontWeight: "500" }}
            >
              {opt.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ListedCompaniesFilter;
